import { NovaErrorCode, isReserve } from '@nova/core';

const entityTermMap = {
  Appointment: 'Appointment',
  AuditLog: 'Audit Log',
  Carrier: 'Carrier Contact',
  Company: 'Company',
  Dock: 'Dock',
  LoadType: 'Load Type',
  Org: 'Organization',
  User: 'User',
  Warehouse: 'Warehouse',
  WarehouseGroup: 'Warehouse Group'
};

const notificationConfigs = {
  success: {
    icon: 'mdi-check-circle-outline',
    appClasses: 'success'
  },
  error: {
    icon: 'mdi-alert-circle-outline',
    appClasses: 'error'
  },
  warning: {
    icon: 'mdi-alert-circle-outline',
    appClasses: 'warning'
  },
  info: {
    icon: 'mdi-information-outline',
    appClasses: 'info'
  }
};

const notificationTitles = {
  [NovaErrorCode.ExternalValidationFailure]: 'Warehouse Rule Failed',
  [NovaErrorCode.ExternalValidationServerError]: 'Validation Server Error'
};

export default {
  getEntityTerm(entity) {
    const entityName = entity?.entity ?? '';
    let entityTerm = entityTermMap[entityName] || '';

    /*
     * TODO: This logic is not ideal, as it knows about an specific type
     * of appointment. For the future, use some kind of generic "alias" coming
     * from the backend.
     *
     * `entity.data` is guarded because this runs on EVERY axios response: any body that merely
     * has an `entity` string property (e.g. a Webhook row, whose `entity` field names the
     * subscribed entity) matches entityTermMap without being a CRUD envelope, so `data` is
     * absent. isReserve throws on nullish by contract, which would reject an otherwise
     * successful request.
     */
    if (entityTerm && entity?.data && isReserve(entity.data)) {
      entityTerm += ' (Reserve)';
    }

    return entityTerm;
  },
  getNotificationConfig(type) {
    return notificationConfigs[type];
  },
  getNotificationTitleByRespCode(responseCode) {
    if (!responseCode) {
      return null;
    }
    return notificationTitles[responseCode] ?? null;
  },
  showAppointmentValidationBypassNotification(appointmentData, notifyFn = null, isUpdate = false) {
    let msg = `Appointment was ${
      isUpdate ? 'updated' : 'created'
    }, but it failed external validation.`;
    if (appointmentData.metadata?.externalValidationErrorMessage) {
      msg += `<br /> Validation Error: ${appointmentData.metadata.externalValidationErrorMessage}`;
    }
    const notificationOptions = {
      title: `Appointment ${isUpdate ? 'updated' : 'created'} with validation error`,
      duration: 10000
    };
    if (notifyFn) {
      notifyFn(msg, 'warning', notificationOptions);
    }
    return {
      msg,
      type: 'warning',
      ...notificationOptions
    };
  },
  showAppointmentSuccessNotification({
    appointmentData,
    notifyFn,
    defaultMessage,
    isUpdate = false
  }) {
    const metadata = appointmentData.metadata;
    if (metadata?.externalValidationFailed === true) {
      this.showAppointmentValidationBypassNotification(appointmentData, notifyFn, isUpdate);
    } else {
      notifyFn(defaultMessage, 'success');
    }
  }
};
